export const permissions = {
  admin: [
    "loop",
    "demosPage",
    "addMentorSlot",
    "classesPage",
    "uploadCsv",
    "AddStudent",
    "createGlimpseEntry",
    "edit_Payment",
    "viewPaymentDetails",
    "bookDemo",
    "pauseClass",
    "initiateRefund",
    "impersonateUser",
    "appImpersonation",
    "coursesPage",
    "addCourseOnCoursesPage",
    "editCourseOnCoursesPage",
    "addBatchLoop",
    "EditBatchLoop",
    "autoAddSlot",
    "disableSlots",
    "userPage",
    "promotions",
    "viewSlots",
    "viewStudentList",
    "viewStudentHistory",
    "bootCamp",
    "alchemy",
    "Community",
    "manageStorefront",
    "mentorShifts",
    "GlmipsePage",
    "managePromotions",
    "Community",
    "deleteStudentInEditOrder",
    "addCourseInEditOrder",
    "addStudentInEditOrder",
    "deleteCourseInEditOrder",
    "writePermissionsInEditOrder",
    "changeDemoMentorInEditOrder",
    "editClassOnViewSchedule",
    "cancelClassOnViewSchedule",
    "substituteMentorOnViewSchedule",
    "createGlimpseEntryOnViewSchedule",
    "deleteExtraClassOnViewSchedule",
    "reschedulePTMOnViewSchedule",
    "viewConversions",
    "sendOnboardingRequest",
    "bulkCancellations",
    "expireCourse",
    "events",
    "referral",
    "createManualRefundOnViewSchedule",
    "mentorExit",
    "mentorLMS",
    "sprReview",
  ],
  mentor: [
    "demosPage",
    "addMentorSlot",
    "GlmipsePage",
    "Community",
    "loop",
    "mentorDashboard",
    "mentorDashboardV2",
    "viewSlots",
    "classesPage",
    "viewStudentList",
    "viewStudentHistory",
    "viewConversions",
    "viewTeachersDayPosts",
    "bulkCancellations",
    "tasks",
    "myCourses",
    "sprReview",
  ],
  // Mentor LMS req 2/5: a temp mentor's ONLY page is Mentor Tutorials —
  // deliberately not spread from `mentor`, so a future permission added there
  // never silently leaks here. Full nav/route lockdown is R7.
  temp_mentor: [
    "myCourses",
  ],
  bd_person: [
    "demosPage",
    "viewSlots",
    "classesPage",
    "promotions",
    "AddStudent",
    "viewPaymentDetails",
    "sendOnboardingRequest",
    "events",
    "mentorLMS",
  ],
  // Pre-merge CSM. Kept as the flag-OFF path for SPRIN-3237 — see MERGED_CSM_PERMISSIONS below.
  cs_person: [
    "loop",
    "demosPage",
    "addBatchLoop",
    "EditBatchLoop",
    "viewSlots",
    "classesPage",
    "sendOnboardingRequest",
    "bulkCancellations",
    "events",
    "mentorLMS",
  ],

  Moderator: [
    "loop",
    "coursesPage",
    "demosPage",
    "addBatchLoop",
    "EditBatchLoop",
    "classesPage",
    "viewSlots",
    "impersonateUser",
    "deleteStudentInEditOrder",
    "addCourseInEditOrder",
    "addStudentInEditOrder",
    "deleteCourseInEditOrder",
    "writePermissionsInEditOrder",
    "changeDemoMentorInEditOrder",
    "editClassOnViewSchedule",
    "cancelClassOnViewSchedule",
    "substituteMentorOnViewSchedule",
    "deleteExtraClassOnViewSchedule",
    "reschedulePTMOnViewSchedule",
    "sendOnboardingRequest",
    "bulkCancellations",
    "events",
    "mentorExit",
    "userPage",
    "mentorLMS",
    "sprReview",
  ],

  bd_manager: [
    "demosPage",
    "classesPage",
    "coursesPage",
    "viewSlots",
    "Community",
    "AddStudent",
    "viewPaymentDetails",
    "sendOnboardingRequest",
    "events",
    "mentorExit",
    "mentorLMS",
  ],
  affiliate_partner: ["demosPage", "affiliateDemos"],
};

// SPRIN-3237 — what a cs_person resolves to once the merge flag is ON, and what a Moderator
// resolves to always.
//
// It is Moderator's own list, not a third one: the pre-merge cs_person list above is a strict
// SUBSET of it (zero permissions were unique to cs_person), so switching to this only ever adds.
// The 14 additions are coursesPage, impersonateUser, userPage, mentorExit, the five
// *OnViewSchedule entries and the five *EditOrder ones. Measured deltas: EpicenterApi
// docs/specs/moderator-csm-role-merge.md §2.
//
// Note what is NOT here: the merged role stays well short of admin, which keeps 30 permissions of
// its own (initiateRefund, edit_Payment, pauseClass, expireCourse, promotions, alchemy and the
// rest). Merging Moderator into CSM does not make a CSM an admin.
//
// Sharing the array with `Moderator` rather than copying it is deliberate. A stale "Moderator"
// session and a migrated "cs_person" session resolve to exactly the same permissions, so the
// migration cannot be observed as a capability change mid-session — the API self-heals within a
// minute (access tokens last 1m and are re-minted from the database), but the browser keeps its
// cached login payload until the user signs in again.
//
// Collapsed into cs_person by the follow-up cleanup, once the migration has run.
export const MERGED_CSM_PERMISSIONS = permissions.Moderator;
